/**
 * DEFAULT_MONETARY_OBLIGATIONS_HTML — fallback content rendered when the CMS provides no
 * description for additional monetary obligations.
 *
 * References Polish legal text required for residential development pre-sale disclosures
 * (art. 19a ust. 1 pkt 3 ustawy z dnia 21 maja 2025).
 *
 * TODO: select key by active i18n language when multi-locale support is added.
 */
export const DEFAULT_MONETARY_OBLIGATIONS_HTML = {
  pl: `<p>
    Inne świadczenia, o których mowa w art. 19a ust. 1 pkt
    3) ustawy z dnia 21 maja 2025 roku o zmianie ustawy o
    ochronie praw nabywcy lokalu mieszkalnego lub domu
    jednorodzinnego oraz Deweloperskim Funduszu Gwarancyjnym:
    <ul>
      <li>koszty aktów notarialnych i opłat sądowych</li>
      <li>koszty zmian aranżacyjnych/programów wykończeniowych wg indywidualnego kosztorysu</li>
      <li>koszty zarządzania i administrowania częściami wspólnymi</li>
      <li>koszty eksploatacji i utrzymania lokalu oraz praw związanych</li>
      <li>koszty związane z cesją praw i obowiązków na innego nabywcę</li>
    </ul>
  </p>`,

  en: `<p>
    Other obligations referred to in Article 19a(1)(3) of the Act of
    21 May 2025 amending the Act on the Protection of the Rights of a
    Buyer of a Residential Premises or a Single-Family House and the
    Developer's Guarantee Fund:
    <ul>
      <li>costs of notarial deeds and court fees</li>
      <li>costs of fit-out changes / finishing programmes per individual estimate</li>
      <li>costs of managing and administering common areas</li>
      <li>costs of operating and maintaining the unit and related rights</li>
      <li>costs related to the assignment of rights and obligations to another purchaser</li>
    </ul>
  </p>`,
}
